import { useState, useEffect } from 'react';
import { UserService } from '../services/UserService';
export const useUserData = (userId) => {
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const userService = UserService.getInstance();
    useEffect(() => {
        if (!userId) {
            setUserData(null);
            return;
        }
        setIsLoading(true);
        setError(null);
        // Подписываемся на изменения данных пользователя
        const unsubscribe = userService.onUserDataChange(userId, (data) => {
            setUserData(data);
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, [userId, userService]);
    return {
        userData,
        isLoading,
        error
    };
};
